// This file will be processed at build time to inject environment variables
// The string will be replaced with the actual value
export const REOWN_PROJECT_ID = '665b956630a31fb5d3327aec41ea483a';